import { VStack, Text, Box, Flex, Icon, For } from "@chakra-ui/react";
import { GiCheckMark } from "react-icons/gi";
import { useTranslations } from "next-intl";
interface Props {
  value: string;
}

export const PasswordStrength = ({ value }: Props) => {
  const t = useTranslations("auth.register.password_required");

  const requirements = [
    {
      key: "lowercase",
      regex: /[a-z]/,
      text: t("lowercase"),
    },
    {
      key: "uppercase",
      regex: /[A-Z]/,
      text: t("uppercase"),
    },
    {
      key: "number",
      regex: /[0-9]/,
      text: t("number"),
    },
    {
      key: "special",
      regex: /[@$!%*?&]/,
      text: t("special"),
    },
    {
      key: "length",
      regex: /.{8,}/,
      text: t("length"),
    },
  ];

  return (
    <Box>
      <Text color="neutral.400" textStyle="sm">
        {t("title")}
      </Text>
      <VStack alignItems={"flex-start"} mt={2}>
        <For each={requirements}>
          {({ key, regex, text }) => (
            <Flex alignItems="center" key={key}>
              <Icon
                fill={regex.test(value) ? "primary.100" : "neutral.100"}
                boxSize={3}
              >
                <GiCheckMark />
              </Icon>
              <Text
                textStyle="sm"
                color={regex.test(value) ? "primary.100" : "neutral.400"}
                ml={2}
              >
                {text}
              </Text>
            </Flex>
          )}
        </For>
      </VStack>
    </Box>
  );
};
